import { render } from "./SessionDetailPage.vue?vue&type=template&id=17a32880&ts=true"
import script from "./SessionDetailPage.vue?vue&type=script&lang=ts"
export * from "./SessionDetailPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__